import { h } from "preact";
import { Text } from "preact-i18n";

const IsLoading = () => [
  <Text id="components.Data wordt geladen">Data wordt geladen</Text>,
  "..."
];

export default IsLoading;
